var map = {
	"./15_happy.mp3": "b817f",
	"./16_sad.mp3": "0010",
	"./17_calm.mp3": "1a1a",
	"./18_angry.mp3": "df9d",
	"./19_sleepy.mp3": "4018",
	"./20_hungry.mp3": "c90b9",
	"./21_scared.mp3": "bd69",
	"./22_mummy.mp3": "0828",
	"./23_daddy.mp3": "984a",
	"./24_sister.mp3": "fb67",
	"./25_brother.mp3": "ac0b",
	"./26_baby.mp3": "9c4b",
	"./27_grandma.mp3": "392f",
	"./28_grandpa.mp3": "1406",
	"./M_Brilliant.mp3": "2daa",
	"./M_Excellent.mp3": "9bae",
	"./M_Fantastic.mp3": "faa5",
	"./M_Great.mp3": "0237",
	"./M_Perfect.mp3": "1324",
	"./M_Think again.mp3": "581f",
	"./M_Try again.mp3": "bca5",
	"./M_Very good.mp3": "b177",
	"./M_Well done.mp3": "f0c5",
	"./M_Work harder.mp3": "3f88",
	"./click.mp3": "1dd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0737";